import { keyframes, style } from "@vanilla-extract/css";
import { calc } from "@vanilla-extract/css-utils";
import { getColorWithOpacity } from "./colors";
import { vars } from "./theme.css";

export const textTruncate = style({
  overflow: "hidden",
  textOverflow: "ellipsis",
  textWrap: "nowrap",
  whiteSpace: "nowrap",
});

export const visuallyHidden = style({
  position: "absolute",
  clipPath: "inset(50%)",
  margin: "-1px",
  border: 0,
  padding: 0,
  width: "1px",
  height: "1px",
  overflow: "hidden",
  whiteSpace: "nowrap",
});

export const borderedCell = style({
  position: "relative",

  selectors: {
    "&::after": {
      position: "absolute",
      top: "1rem",
      bottom: "1rem",
      insetInlineEnd: 0,
      display: "block",
      borderRadius: "1px",
      background: vars.colors.outlineVariant,
      width: "1px",
      content: '""',
    },
  },
});

// Widths for element table columns
export const statusCellWidth = "10%";
export const elementInTableCellWidth = "50%";
export const statCellWidth = "15%";
export const addElementCellWidth = "10%";

// Simple style to extend content to container edges. Use for pitch
export const edgeToEdge = style({
  marginInlineStart: calc.negate(vars.space.m),
  marginInlineEnd: calc.negate(vars.space.m),
});

const rotate = keyframes({
  "0%": { transform: "rotate(0deg)" },
  "100%": { transform: "rotate(360deg)" },
});

export const rotating = style({
  animation: `${rotate} 1s ease-in-out`,

  "@media": {
    "(prefers-reduced-motion: reduce)": {
      animation: "none",
    },
  },
});

export const footnote = style({
  color: vars.colors.onSurface,
  fontSize: vars.fontSizes.body.xs,
});

export const scrollContainer = style({
  // Keep horizontal scrolling contained to the table so it doesn't chain to
  // the page/rubber-band past the container edge on touch devices.
  maxWidth: "100%",
  overflow: "auto",
  overscrollBehaviorX: "contain",
});

export const fixedTable = style({
  tableLayout: "fixed",
  whiteSpace: "nowrap",
});

export const fluidImage = style({
  display: "block",
  width: "100%",
  maxWidth: "100%",
  height: "auto",
});

// TODO: uncomment to re enable sticky action bar
export const actionBar = style([
  edgeToEdge,
  {
    position: "sticky",
    zIndex: vars.zIndex.actionBar,
    bottom: 0,
    transition: "opacity 150ms ease, transform 150ms ease",
    backgroundColor: vars.colors.surface,
    padding: `${vars.space.s} ${vars.space.m}`,
  },
]);

const modalFade = keyframes({
  from: { opacity: "0" },
  to: { opacity: "1" },
});

const modalFadeOut = keyframes({
  from: { opacity: "1" },
  to: { opacity: "0" },
});

export const modalOverlay = style({
  position: "fixed",
  zIndex: vars.zIndex.modal,
  inset: 0,
  display: "flex",
  // make sure it is higher than the pulse header with 600 zindex
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: getColorWithOpacity(vars.colors.overlay, 80),
  selectors: {
    "&[data-entering]": {
      animation: `${modalFade} 150ms forwards`,
    },
    "&[data-exiting]": {
      animation: `${modalFadeOut} 150ms forwards`,
    },
  },
  "@media": {
    "(prefers-reduced-motion: reduce)": {
      selectors: {
        "&[data-entering], &[data-exiting]": {
          animation: "none",
        },
      },
    },
  },
});

export const rtlRotate180 = style({
  selectors: {
    '[dir="rtl"] &': {
      transform: "rotate(180deg)",
    },
  },
});

export const titleContainer = style({
  paddingTop: vars.space.s,
});
